import React = require("react");
import {connect} from "react-redux";
import {iState} from "./store";

function _roundLabels(l: string): string {
    let parts = l.split(' - ');
    let start = parseFloat(parts[0]);
    let end = parseFloat(parts[1]);

    start = parseInt((start * 10).toFixed()) / 10;
    end = parseInt((end * 10).toFixed()) / 10;

    return `${start} to ${end}`
}

class _Legend extends React.Component<{ metric: string, legend: object[] }, {}> {


    render() {

        let liArr = [];


        for (let l of this.props.legend) {
            let rounded = (l['label'] as string).replace(/-?\d+(\.\d+)?/g, (s) => {
                console.log(s);
                let v = parseFloat(s);
                return `${parseInt((v * 10).toFixed()) / 10}`;
            });
            rounded = rounded.replace(' - ', ' to ')

            liArr.push(<li key={rounded}>
                <img alt="" src={`data:image/png;base64,${l['imageData']}`} style={{marginRight: '5px'}}/>
                {rounded}
            </li>);
            //
        }


        return <div>
            <ul style={{listStyle: 'none'}}>
                {liArr}
            </ul>
        </div>
    }
}

export const Legend = connect(
    (s: iState) => {
        return {metric: s.metric, legend: s.legend}
    }
)(_Legend);
